webpackJsonp([10],{

/***/ 2766:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _channels = __webpack_require__(783);

var _teams = __webpack_require__(274);

var _create_team = __webpack_require__(2767);

var _create_team2 = _interopRequireDefault(_create_team);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var license = (0, _general.getLicense)(state);
    var currentChannel = (0, _channels.getCurrentChannel)(state);
    var currentTeam = (0, _teams.getCurrentTeam)(state);

    var isLicensed = license.IsLicensed === 'true';
    var customDescriptionText = config.CustomDescriptionText;
    var siteName = config.SiteName;

    return {
        currentChannel: currentChannel,
        currentTeam: currentTeam,
        isLicensed: isLicensed,
        customDescriptionText: customDescriptionText,
        siteName: siteName
    };
} // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_create_team2.default);

/***/ }),

/***/ 2767:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

var _announcement_bar = __webpack_require__(882);

var _announcement_bar2 = _interopRequireDefault(_announcement_bar);

var _back_button = __webpack_require__(852);

var _back_button2 = _interopRequireDefault(_back_button);

var _display_name = __webpack_require__(2768);

var _display_name2 = _interopRequireDefault(_display_name);

var _site_name_and_description = __webpack_require__(941);

var _site_name_and_description2 = _interopRequireDefault(_site_name_and_description);

var _team_url = __webpack_require__(2769);

var _team_url2 = _interopRequireDefault(_team_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CreateTeam = function (_React$PureComponent) {
    (0, _inherits3.default)(CreateTeam, _React$PureComponent);

    function CreateTeam(props) {
        (0, _classCallCheck3.default)(this, CreateTeam);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CreateTeam.__proto__ || (0, _getPrototypeOf2.default)(CreateTeam)).call(this, props));

        _initialiseProps.call(_this);

        var state = {};
        state.team = {};
        state.wizard = 'display_name';
        _this.state = state;
        return _this;
    }

    (0, _createClass3.default)(CreateTeam, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                currentChannel = _props.currentChannel,
                currentTeam = _props.currentTeam,
                customDescriptionText = _props.customDescriptionText,
                isLicensed = _props.isLicensed,
                match = _props.match,
                siteName = _props.siteName;


            var url = '/select_team';
            if (currentTeam) {
                url = '/' + currentTeam.name;
                if (currentChannel) {
                    url += '/channels/' + currentChannel.name;
                }
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_announcement_bar2.default, null),
                _react2.default.createElement(_back_button2.default, { url: url }),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'signup-team__container' },
                        _react2.default.createElement(_site_name_and_description2.default, {
                            customDescriptionText: customDescriptionText,
                            isLicensed: isLicensed,
                            siteName: siteName
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'signup__content' },
                            _react2.default.createElement(
                                _reactRouterDom.Switch,
                                null,
                                _react2.default.createElement(_reactRouterDom.Route, {
                                    path: this.props.match.url + '/display_name',
                                    render: function render(props) {
                                        return _react2.default.createElement(_display_name2.default, (0, _extends3.default)({
                                            state: _this2.state,
                                            updateParent: _this2.updateParent
                                        }, props));
                                    }
                                }),
                                _react2.default.createElement(_reactRouterDom.Route, {
                                    path: this.props.match.url + '/team_url',
                                    render: function render(props) {
                                        return _react2.default.createElement(_team_url2.default, (0, _extends3.default)({
                                            state: _this2.state,
                                            updateParent: _this2.updateParent
                                        }, props));
                                    }
                                }),
                                _react2.default.createElement(_reactRouterDom.Redirect, { to: match.url + '/display_name' })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return CreateTeam;
}(_react2.default.PureComponent);

CreateTeam.propTypes = {

    /*
     * Object containing information on the current team, used to define BackButton's url
     */
    currentTeam: _propTypes2.default.object,

    /*
     * Object containing information on the current selected channel, used to define BackButton's url
     */
    currentChannel: _propTypes2.default.object,

    /*
     * Boolean value that determines whether server has a valid Enterprise license
     */
    isLicensed: _propTypes2.default.bool.isRequired,

    /*
     * String containing the custom branding's text
     */
    customDescriptionText: _propTypes2.default.string,

    /*
     * String containing the custom branding's Site Name
     */
    siteName: _propTypes2.default.string,

    /*
     * Object from react-router
     */
    match: _propTypes2.default.shape({
        url: _propTypes2.default.string.isRequired
    }).isRequired
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.updateParent = function (state) {
        _this3.setState(state);
        _this3.props.history.push('/create_team/' + state.wizard);
    };
};

exports.default = CreateTeam;

/***/ }),

/***/ 2768:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _diagnostics_actions = __webpack_require__(804);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _url = __webpack_require__(793);

var _logo = __webpack_require__(851);

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TeamSignupDisplayNamePage = function (_React$PureComponent) {
    (0, _inherits3.default)(TeamSignupDisplayNamePage, _React$PureComponent);

    function TeamSignupDisplayNamePage(props) {
        (0, _classCallCheck3.default)(this, TeamSignupDisplayNamePage);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamSignupDisplayNamePage.__proto__ || (0, _getPrototypeOf2.default)(TeamSignupDisplayNamePage)).call(this, props));

        _this.submitNext = function (e) {
            e.preventDefault();

            var displayName = _reactDom2.default.findDOMNode(_this.refs.name).value.trim();
            if (!displayName) {
                _this.setState({ nameError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'create_team.display_name.required',
                        defaultMessage: 'This field is required'
                    })
                });
                return;
            } else if (displayName.length < _constants2.default.MIN_TEAMNAME_LENGTH || displayName.length > _constants2.default.MAX_TEAMNAME_LENGTH) {
                _this.setState({ nameError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'create_team.display_name.charLength',
                        defaultMessage: 'Name must be {min} or more characters up to a maximum of {max}. You can add a longer team description later.',
                        values: {
                            min: _constants2.default.MIN_TEAMNAME_LENGTH,
                            max: _constants2.default.MAX_TEAMNAME_LENGTH
                        }
                    })
                });
                return;
            }

            var newState = _this.props.state;
            newState.wizard = 'team_url';
            newState.team.display_name = displayName;
            newState.team.name = (0, _url.cleanUpUrlable)(displayName);
            _this.props.updateParent(newState);
        };

        _this.handleFocus = function (e) {
            e.preventDefault();
            e.currentTarget.select();
        };

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(TeamSignupDisplayNamePage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _diagnostics_actions.trackEvent)('signup', 'signup_team_01_name');
        }
    }, {
        key: 'render',
        value: function render() {
            var nameError = null;
            var nameDivClass = 'form-group';
            if (this.state.nameError) {
                nameError = _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    this.state.nameError
                );
                nameDivClass += ' has-error';
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement('img', {
                        className: 'signup-team-logo',
                        src: _logo2.default
                    }),
                    _react2.default.createElement(
                        'h2',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'create_team.display_name.teamName',
                            defaultMessage: 'Team Name'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: nameDivClass },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-9' },
                                _react2.default.createElement('input', {
                                    type: 'text',
                                    ref: 'name',
                                    className: 'form-control',
                                    placeholder: '',
                                    maxLength: '128',
                                    defaultValue: this.props.state.team.display_name,
                                    autoFocus: true,
                                    onFocus: this.handleFocus,
                                    spellCheck: 'false'
                                })
                            )
                        ),
                        nameError
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'create_team.display_name.nameHelp',
                            defaultMessage: 'Name your team in any language. Your team name shows in menus and headings.'
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'submit',
                            className: 'btn btn-primary margin--extra',
                            onClick: this.submitNext
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'create_team.display_name.next',
                            defaultMessage: 'Next'
                        }),
                        _react2.default.createElement('i', { className: 'fa fa-chevron-right' })
                    )
                )
            );
        }
    }]);
    return TeamSignupDisplayNamePage;
}(_react2.default.PureComponent);

TeamSignupDisplayNamePage.propTypes = {

    /*
     * Object containing team's display_name and name
     */
    state: _propTypes2.default.object,

    /*
     * Function that updates parent component with state props
     */
    updateParent: _propTypes2.default.func
};
exports.default = TeamSignupDisplayNamePage;

/***/ }),

/***/ 2769:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(1);

var _reactRedux = __webpack_require__(268);

var _teams = __webpack_require__(816);

var _team_url = __webpack_require__(2770);

var _team_url2 = _interopRequireDefault(_team_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            checkIfTeamExists: _teams.checkIfTeamExists,
            createTeam: _teams.createTeam
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_team_url2.default);

/***/ }),

/***/ 2770:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _diagnostics_actions = __webpack_require__(804);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _url = __webpack_require__(793);

var URL = _interopRequireWildcard(_url);

var _logo = __webpack_require__(851);

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeamUrl = function (_React$PureComponent) {
    (0, _inherits3.default)(TeamUrl, _React$PureComponent);

    function TeamUrl(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, TeamUrl);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamUrl.__proto__ || (0, _getPrototypeOf2.default)(TeamUrl)).call(this, props));

        _this.submitBack = function (e) {
            e.preventDefault();
            var newState = _this.props.state;
            newState.wizard = 'display_name';
            _this.props.updateParent(newState);
        };

        _this.submitNext = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(e) {
                var name, cleanedName, urlRegex, _this$props$actions, checkIfTeamExists, createTeam, index, teamSignup, _ref2, exists, _ref3, data, error;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                e.preventDefault();

                                name = _reactDom2.default.findDOMNode(_this.refs.name).value.trim();
                                cleanedName = URL.cleanUpUrlable(name);
                                urlRegex = /^[a-z]+([a-z\-0-9]+|(__)?)[a-z0-9]+$/g;
                                _this$props$actions = _this.props.actions, checkIfTeamExists = _this$props$actions.checkIfTeamExists, createTeam = _this$props$actions.createTeam;

                                if (name) {
                                    _context.next = 8;
                                    break;
                                }

                                _this.setState({ nameError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'create_team.team_url.required',
                                        defaultMessage: 'This field is required'
                                    })
                                });
                                return _context.abrupt('return');

                            case 8:
                                if (!(cleanedName.length < _constants2.default.MIN_TEAMNAME_LENGTH || cleanedName.length > _constants2.default.MAX_TEAMNAME_LENGTH)) {
                                    _context.next = 11;
                                    break;
                                }

                                _this.setState({ nameError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'create_team.team_url.charLength',
                                        defaultMessage: 'Name must be {min} or more characters up to a maximum of {max}',
                                        values: {
                                            min: _constants2.default.MIN_TEAMNAME_LENGTH,
                                            max: _constants2.default.MAX_TEAMNAME_LENGTH
                                        }
                                    })
                                });
                                return _context.abrupt('return');

                            case 11:
                                if (!(cleanedName !== name || !urlRegex.test(name))) {
                                    _context.next = 14;
                                    break;
                                }

                                _this.setState({ nameError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'create_team.team_url.regex',
                                        defaultMessage: 'Use only lower case letters, numbers and dashes. Must start with a letter and can\'t end in a dash.'
                                    })
                                });
                                return _context.abrupt('return');

                            case 14:
                                index = 0;

                            case 15:
                                if (!(index < _constants2.default.RESERVED_TEAM_NAMES.length)) {
                                    _context.next = 22;
                                    break;
                                }

                                if (!(cleanedName.indexOf(_constants2.default.RESERVED_TEAM_NAMES[index]) === 0)) {
                                    _context.next = 19;
                                    break;
                                }

                                _this.setState({ nameError: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                        id: 'create_team.team_url.taken',
                                        defaultMessage: 'This URL <a href="https://docs.mattermost.com/help/getting-started/creating-teams.html#team-url" target="_blank">starts with a reserved word</a> or is unavailable. Please try another.'
                                    })
                                });
                                return _context.abrupt('return');

                            case 19:
                                index++;
                                _context.next = 15;
                                break;

                            case 22:

                                _this.setState({ isLoading: true });
                                teamSignup = JSON.parse((0, _stringify2.default)(_this.props.state));

                                teamSignup.team.type = 'O';
                                teamSignup.team.name = name;

                                _context.next = 28;
                                return checkIfTeamExists(name);

                            case 28:
                                _ref2 = _context.sent;
                                exists = _ref2.exists;

                                if (!exists) {
                                    _context.next = 34;
                                    break;
                                }

                                _this.setState({ nameError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'create_team.team_url.unavailable',
                                        defaultMessage: 'This URL is taken or unavailable. Please try another.'
                                    })
                                });
                                _this.setState({ isLoading: false });
                                return _context.abrupt('return');

                            case 34:
                                _context.next = 36;
                                return createTeam(teamSignup.team);

                            case 36:
                                _ref3 = _context.sent;
                                data = _ref3.data;
                                error = _ref3.error;


                                if (data) {
                                    _this.props.history.push('/' + data.name + '/channels/town-square');
                                    (0, _diagnostics_actions.trackEvent)('signup', 'signup_team_03_complete');
                                } else if (error) {
                                    _this.setState({ nameError: error.message });
                                    _this.setState({ isLoading: false });
                                }

                            case 40:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.handleFocus = function (e) {
            e.preventDefault();
            e.currentTarget.select();
        };

        _this.state = {
            nameError: '',
            isLoading: false
        };
        return _this;
    }

    (0, _createClass3.default)(TeamUrl, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _diagnostics_actions.trackEvent)('signup', 'signup_team_02_url');
        }
    }, {
        key: 'render',
        value: function render() {
            var nameError = null;
            var nameDivClass = 'form-group';
            if (this.state.nameError) {
                nameError = _react2.default.createElement(
                    'label',
                    { className: 'control-label' },
                    this.state.nameError
                );
                nameDivClass += ' has-error';
            }

            var title = URL.getSiteURL() + '/';
            var urlTooltip = _react2.default.createElement(
                _reactBootstrap.Tooltip,
                { id: 'urlTooltip' },
                title
            );

            var finishMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'create_team.team_url.finish',
                defaultMessage: 'Finish'
            });

            if (this.state.isLoading) {
                finishMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'create_team.team_url.creatingTeam',
                    defaultMessage: 'Creating team...'
                });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement('img', {
                        className: 'signup-team-logo',
                        src: _logo2.default
                    }),
                    _react2.default.createElement(
                        'h2',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'create_team.team_url.teamUrl',
                            defaultMessage: 'Team URL'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: nameDivClass },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-11' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-group input-group--limit' },
                                    _react2.default.createElement(
                                        _reactBootstrap.OverlayTrigger,
                                        {
                                            trigger: ['hover', 'focus'],
                                            delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                            placement: 'top',
                                            overlay: urlTooltip
                                        },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'input-group-addon' },
                                            title
                                        )
                                    ),
                                    _react2.default.createElement('input', {
                                        type: 'text',
                                        ref: 'name',
                                        className: 'form-control',
                                        placeholder: '',
                                        maxLength: '128',
                                        defaultValue: this.props.state.team.name,
                                        autoFocus: true,
                                        onFocus: this.handleFocus,
                                        spellCheck: 'false'
                                    })
                                )
                            )
                        ),
                        nameError
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'create_team.team_url.webAddress',
                            defaultMessage: 'Choose the web address of your new team:'
                        })
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'color--light' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'create_team.team_url.hint',
                            defaultMessage: '<li>Short and memorable is best</li> <li>Use lowercase letters, numbers and dashes</li> <li>Must start with a letter and can\'t end in a dash</li>'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'margin--extra' },
                        _react2.default.createElement(
                            _reactBootstrap.Button,
                            {
                                type: 'submit',
                                bsStyle: 'primary',
                                disabled: this.state.isLoading,
                                onClick: this.submitNext
                            },
                            finishMessage
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'margin--extra' },
                        _react2.default.createElement(
                            'a',
                            {
                                href: '#',
                                onClick: this.submitBack
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'create_team.team_url.back',
                                defaultMessage: 'Back to previous step'
                            })
                        )
                    )
                )
            );
        }
    }]);
    return TeamUrl;
}(_react2.default.PureComponent); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

TeamUrl.propTypes = {

    /*
     * Object containing team's display_name and name
     */
    state: _propTypes2.default.object,

    /*
     * Function that updates parent component with state props
     */
    updateParent: _propTypes2.default.func,

    /*
     * Object with redux action creators
     */
    actions: _propTypes2.default.shape({

        /*
         * Action creator to check if a team already exists
         */
        checkIfTeamExists: _propTypes2.default.func.isRequired,

        /*
         * Action creator to create a new team
         */
        createTeam: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = TeamUrl;

/***/ })

});


// WEBPACK FOOTER //
// 10.81b0acef34d339d4bb5f.js